import { render, staticRenderFns } from "./TapsTable.vue?vue&type=template&id=2cdf7b38&scoped=true&"
import script from "./TapsTable.vue?vue&type=script&lang=js&"
export * from "./TapsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdf7b38",
  null
  
)

export default component.exports